import "babel-polyfill";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from "vue";
import lodash from "lodash";
import VueLodash from "vue-lodash/dist/vue-lodash.min";
import "quasar-framework/dist/umd/quasar.mat.css";
import Quasar from "quasar-framework/dist/quasar.mat.esm";
import "@/style/app.scss";
import Chart from "vue2-frappe";
import LoadScript from "vue-plugin-load-script";
import VueLocalStorage from 'vue-localstorage'
import { en, de } from "vuejs-datepicker/dist/locale";
import bugsnag from "@bugsnag/js";
import bugsnagVue from "@bugsnag/plugin-vue";

import store from "@/store";
import ClickOutside from "@/directives/ClickOutside";
import Can from "@/directives/Can";
import CanDom from "@/directives/CanDom";
import App from "@/App";
import i18n from "@/i18n";
import router from "@/config/router";
import Permission from '@/classes/Permission'
  
if (process.env.BUGSNAG_API_TOKEN) {
  const bugsnagClient = bugsnag(process.env.BUGSNAG_API_TOKEN)

  bugsnagClient.use(bugsnagVue, Vue)
}

// For loading external scripts
Vue.use(LoadScript);

Vue.use(Chart);
Vue.use(Quasar);
Vue.use(VueLocalStorage);

Vue.directive("click-outside", ClickOutside);
Vue.directive("can", Can);
Vue.directive("can-dom", CanDom);
Vue.directive("focus", {
  inserted: function(el) {
    el.focus();
  }
});
Vue.use(VueLodash, lodash);

Vue.config.keyCodes.backspace = 8;
Vue.config.keyCodes.comma = 188;

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    deepUpdate(object, key, value) {
      let newValues = {};
      newValues[key] = value;
      return Object.assign({}, object, newValues);
    },
    generateUuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      })
    },
    hasPermission(operation) {
      let permission = Permission.loadPermissions()
      return Permission.can(permission, operation)
    },
    formatDateTimeNatural(datetime, options = {}) {

      // datetime = A valid date/time string
      // or, set to NULL for now

      // Options:
      // includeTime = true
      // excludeSameYear = true
      // useDateExpressions = true
      // useTimeExpressions = true

      if (datetime === undefined || datetime === '') {
        return ''
      }

      let date = moment(datetime)
      if (!date.isValid()) {
        return ''
      }

      let now = moment()

      // If the time is just a few minutes ago, return an expression
      if (options.useTimeExpressions !== false && date.isSame(now, 'day')) {
        if (now.diff(date, 'seconds') < 20) {
          return this.$t('ui.global.date_time.seconds_ago')
        }
        if (now.diff(date, 'seconds') < 60) {
          return this.$t('ui.global.date_time.less_than_minute')
        }
        if (now.diff(date, 'minutes') < 5) {
          return this.$t('ui.global.date_time.minutes_ago')
        }
      }

      let text = ''

      // If the date is today or yesterday, just return those terms
      if (options.useDateExpressions !== false) {
        text = date.isSame(now, 'day') ? this.$t('ui.global.date_time.today')
                : date.isSame(now.subtract(1, 'day'), 'day') ? this.$t('ui.global.date_time.yesterday')
                : ''
      }

      if (text == '') {
        // Otherwise, return a date and year
        text = date.format('D MMM')
        if (date.isSame(now, 'year') == false || options.excludeSameYear === false) {
          // Only include the year if it's not this year
          text += ' ' + date.format('YYYY')
        }
      }

      if (options.includeTime !== false) {
        text += ' ' + this.$t('ui.global.date_time.at') + ' ' + date.format('H:mm')
      }

      return text
    },
    getDatePickerLanguage() {
      if (this.$store.getters.getCurrentLanguage === 'de') {
        return de
      } else {
        return en
      }
    }
  }
})

new Vue({
  store,
  i18n,
  el: "#app",
  router,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js